var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerLrestederSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.58,15a.28.28,0,0,1-.28-.28V7.34a.28.28,0,0,1,.15-.25.27.27,0,0,1,.29,0,2.84,2.84,0,0,0,2.84.2,2.52,2.52,0,0,1,2.64,0,.3.3,0,0,1,.11.23v3.27a.27.27,0,0,1-.15.25.29.29,0,0,1-.3,0,1.92,1.92,0,0,0-1-.26,2.69,2.69,0,0,0-1,.28,2.59,2.59,0,0,1-2.13.21.28.28,0,0,1-.17-.36.27.27,0,0,1,.36-.17,2.11,2.11,0,0,0,1.72-.19,3.15,3.15,0,0,1,1.22-.34,2.86,2.86,0,0,1,.93.15V7.73a2,2,0,0,0-1.93.08,3.33,3.33,0,0,1-3,0v6.9A.29.29,0,0,1,19.58,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.73,31.24H7.29A.28.28,0,0,1,7,31V29.53a.28.28,0,0,1,.28-.29h.16V21.52H7.29A.28.28,0,0,1,7,21.23V20a.27.27,0,0,1,.28-.28h5.45V16.09h-.16a.28.28,0,0,1-.28-.28v-1a.28.28,0,0,1,.28-.28H26.41a.27.27,0,0,1,.28.28v1a.28.28,0,0,1-.28.28h-.26v3.64h5.61A.28.28,0,0,1,32,20v1.22a.29.29,0,0,1-.28.28H31.5l0,7.73h.19a.29.29,0,0,1,.29.29V31A.29.29,0,0,1,31.73,31.24ZM7.57,30.68H31.45v-.85h-.19a.3.3,0,0,1-.29-.28l0-8.3a.28.28,0,0,1,.08-.2.27.27,0,0,1,.2-.09h.25v-.65h-5.6a.28.28,0,0,1-.28-.28v-4.2a.28.28,0,0,1,.28-.29h.26v-.47H12.87v.46H13a.28.28,0,0,1,.29.28V20a.29.29,0,0,1-.29.28H7.57V21h.16a.28.28,0,0,1,.28.28v8.3a.28.28,0,0,1-.28.28H7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.52,21.08a2.32,2.32,0,1,1,2.32-2.31A2.32,2.32,0,0,1,19.52,21.08Zm0-4.06a1.75,1.75,0,1,0,1.75,1.75A1.75,1.75,0,0,0,19.52,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.54,19.34a.28.28,0,0,1-.28-.28V17.65a.29.29,0,0,1,.28-.28.28.28,0,0,1,.28.28v1.41A.27.27,0,0,1,19.54,19.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.54,19.35h-1a.29.29,0,0,1-.28-.28.28.28,0,0,1,.28-.28h1a.28.28,0,0,1,.28.28A.29.29,0,0,1,19.54,19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,29.79H16.08a.28.28,0,0,1-.28-.28.27.27,0,0,1,.28-.28H23a.27.27,0,0,1,.28.28A.28.28,0,0,1,23,29.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.2,29.65a.28.28,0,0,1-.28-.28l0-5.27a.29.29,0,0,1,.28-.28l4.68,0h0a.27.27,0,0,1,.19.08.28.28,0,0,1,.09.2l0,5.27a.29.29,0,0,1-.28.29h0a.29.29,0,0,1-.28-.28l0-5-4.12,0,0,5a.29.29,0,0,1-.29.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerLrestederSmall);
export default __webpack_public_path__ + "static/media/Ikoner_Læresteder_small.fa04f491de8b04dd220f493683f1fc91.svg";
export { ForwardRef as ReactComponent };